import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg, fmtDate, fmtNum } from "@/lib/api";
import { Empty, Spinner } from "@/components/Brand";
import { PassBadge } from "@/components/ResultTable";
import { PageTitle } from "@/pages/admin/AdminLayout";

const Box = ({ label, value, to, testid }) => (
  <Link to={to} className="card-premium block p-5" data-testid={testid}>
    <div className="text-xs font-bold uppercase tracking-widest text-slate-400">{label}</div>
    <div className="mt-2 font-display text-3xl font-extrabold text-[#0A192F]">{value}</div>
  </Link>
);

export default function Overview() {
  const [s, setS] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data)).catch((e) => setErr(errMsg(e)));
  }, []);
  if (err) return <Empty text={err} />;
  if (!s) return <Spinner />;
  return (
    <div>
      <PageTitle title="Ringkasan" desc="Seluruh angka diambil langsung dari database." />
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <Box label="Total peserta" value={s.participants} to="/admin/peserta" testid="stat-box-participants" />
        <Box label="Total kategori" value={s.categories} to="/admin/kategori" testid="stat-box-categories" />
        <Box label="Total materi" value={s.subjects} to="/admin/materi" testid="stat-box-subjects" />
        <Box label="Total soal" value={s.questions} to="/admin/bank-soal" testid="stat-box-questions" />
        <Box label="Total paket tryout" value={s.packages} to="/admin/paket" testid="stat-box-packages" />
        <Box label="Sedang mengerjakan" value={s.in_progress} to="/admin/hasil" testid="stat-box-inprogress" />
        <Box label="Ujian selesai" value={s.finished} to="/admin/hasil" testid="stat-box-finished" />
        <Box label="Rata-rata skor" value={fmtNum(s.average_score)} to="/admin/statistik" testid="stat-box-average" />
        <Box label="Persentase kelulusan" value={s.pass_rate == null ? "-" : `${fmtNum(s.pass_rate)}%`} to="/admin/statistik" testid="stat-box-passrate" />
        <Box label="Pembayaran menunggu" value={s.pending_payments} to="/admin/pembayaran" testid="stat-box-pending-payments" />
      </div>
      <h2 className="mb-3 mt-10 font-display text-lg font-bold text-[#0A192F]">Hasil ujian terbaru</h2>
      {s.recent.length === 0 ? <Empty text="Belum ada ujian selesai." /> : (
        <div className="overflow-x-auto rounded-xl border bg-white">
          <table className="w-full min-w-[600px] text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500"><tr><th className="px-4 py-3">Peserta</th><th>Paket</th><th>Selesai</th><th>Total</th><th>Status</th></tr></thead>
            <tbody>{s.recent.map((r) => (
              <tr key={r.id} className="border-t"><td className="px-4 py-3"><Link to={`/hasil/${r.id}`} className="font-semibold hover:text-amber-700">{r.user_name}</Link></td><td>{r.package_name}</td><td>{fmtDate(r.finished_at)}</td><td className="font-mono">{fmtNum(r.total)}/{fmtNum(r.max_total)}</td><td><PassBadge passed={r.passed} /></td></tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
